<template>
  <div v-if="socialNetworks.length" class="d-flex flex-column w-100">
    <TextBlock
      variant="secondary"
      :text="
        $t(
          '_web_tournaments_share-settings-label',
          'Automatically share announcement to:'
        )
      "
      class="mb-3"
    />
    <div class="row mt-4 justify-content-center">
      <div
        v-for="network in socialNetworks"
        :key="network"
        class="d-flex align-items-center col-auto"
      >
        <SocialIcon
          :name="`${network === 'facebook' ? 'fb' : network}`"
          :size="24"
        />
        <!-- <TextBlock class="mx-3">{{ network | startCase }}</TextBlock> -->
        <Checkbox
          :checked="getSocialValue(network)"
          class="h-ml-3 flex-grow-0"
          @change="$event => setSocialValue(network, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Checkbox from '@/components/atoms/form/Checkbox';
import SocialIcon from '@/components/images/Social';
import TextBlock from '@/components/atoms/TextBlock';
const defaultSocials = ['facebook', 'twitter'];
export default {
  name: 'TournamentSharingSettings',
  components: {
    Checkbox,
    SocialIcon,
    TextBlock,
  },
  props: {
    socialNetworks: {
      type: Array,
      default: () => defaultSocials,
      validator(val) {
        return val.every(el => defaultSocials.includes(el));
      },
    },
  },
  computed: {
    ...mapGetters(['tournamentRepostSettings']),
  },
  methods: {
    ...mapMutations(['setTournamentReposts']),
    getSocialValue(social) {
      return this.tournamentRepostSettings(social);
    },
    setSocialValue(social, value) {
      this.setTournamentReposts({
        [`repostTo${this.$lodash.startCase(social)}`]: value,
      });
    },
  },
};
</script>

<style></style>
